import { client } from 'Service/axios';
import { IListResponse } from 'Shared/Types/api';
import { IBid } from 'Shared/Types/bid';
import { IAssignedBidPostData, IAssignedBidResponse } from 'Shared/Types/api';

const BIDS_URL = '/orders/my_bids/';

class Bid {
  getBidList({
    page,
    pageSize,
    isHistorical = false,
  }: {
    page?: number;
    pageSize?: number;
    isHistorical?: boolean;
  }) {
    return client.get<IListResponse<IBid[]>>(
      `${BIDS_URL}${isHistorical ? 'history/' : ''}`,
      {
        params: {
          page,
          page_size: pageSize,
        },
      },
    );
  }

  getBid(id: number) {
    return client.get<IBid>(`${BIDS_URL}${id}`);
  }

  assignBid(data: IAssignedBidPostData) {
    return client.post<IAssignedBidResponse>(`${BIDS_URL}assign/`, data);
  }
}

export default Bid;
